var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgEmail = function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 19.212v24.916c0 .539-.471 1.077-1.06 1.077H16.06c-.589 0-1.06-.538-1.06-1.077V19.212c0-.673.471-1.212 1.06-1.212h32.88c.589 0 1.06.539 1.06 1.212zm-32.997 2.29l14.142 11.852c.353.269.825.538 1.296.538.471 0 .943-.27 1.296-.538l14.26-11.852V20.29H17.003v1.212zm30.994 2.828L34.916 35.104c-.707.674-1.532.943-2.475.943-.825 0-1.65-.27-2.475-.943L17.003 24.33v18.72h30.994V24.33z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};
export default SvgEmail;